/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Input, Dropdown, TextArea, Form } from 'semantic-ui-react';
import GBButton from '../../components/GBButton/GBButton';
import Spinner from 'src/components/Spinner/Spinner';
import { aiProcessAPI,aiTextToSpeechLanguages } from '../../api/ai';
import AudioPlayer from './AudioPlayer';

const ActionAITextToSpeech = ({ localData, updateData, editMode, sourceNodes }) => {
  const [isLoading,setIsLoading]=useState(false);
  const [AIProcessName, setAIProcessName] = useState(localData.AIProcessName ?? '');
  const [allFields, setAllFields] = useState([]);
  const [promptMessage, setPromptMessage] = useState(localData.promptMessage ?? '');
  const [APIResponse, setAPIResponse] = useState(localData.apiData ?? null);
  const [tableData, setTableData] = useState(
    localData?.tableData?.name.startsWith('api') ? localData.tableData : {
      name: `api_${localData.id}`,
      id: `api_${localData.id}`,
      tableinfo: { columns: [{data:'publicUrl',header:'Mp3 URL',uitype:2}] },
    },
  );
  const [tokenArray, setTokenArray] = useState(localData.tokenArray ?? []);
  const [languageFilter, setLanguageFilter] = useState('');
  const [genderFilter, setGenderFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [voice, setVoice] = useState(localData.voice ?? 'en-US-Standard-A');
  const [fieldType, setFieldType] =useState(localData.fieldType ?? 4);
  const [languageOptions,setLanguageOptions] = useState([]);

  useEffect(() => {
    getAllFields();
    getLanguages();
  }, []);

  const fieldTypeOptions = [
    {key:'2',value:2,text:'Short text'},
    {key:'4',value:4,text:'Attachment'},
    {key:'11',value:11,text:'URL'},
  ]

  const updateFieldType =(val) =>{
    setFieldType(val);
    tableData.tableinfo.columns[0].uitype=val;
    setTableData(tableData);
    
    localData.fieldType = val;
    localData.tableData = tableData;
    updateData(localData);
  }


  const uniqueLanguages = [...new Set(languageOptions.map((option) => option.language))];
  const FilterLanguages = uniqueLanguages.map((language) => ({
    key: language,
    value: language,
    text: language,
  }));
  
  FilterLanguages.unshift({ key: '', value: '', text: 'Choose one' });

  const FilterTypes = [
    { key: 'choose', value: '', text: 'Choose one' },
    { key: 'standard', value: 'Standard', text: 'Standard' },
    { key: 'wavenet', value: 'Wavenet', text: 'Wavenet' },
    { key: 'neural2', value: 'Neural2', text: 'Neural2' },
    { key: 'chirp', value: 'Chirp-HD', text: 'Chirp-HD' },
    { key: 'chirp3', value: 'Chirp3-HD', text: 'Chirp3-HD' },
    { key: 'news', value: 'News', text: 'News' },
    { key: 'studio', value: 'Studio', text: 'Studio' },
    { key: 'polyglot', value: 'Polyglot', text: 'Polyglot' },
  ];

  const FilterGenders = [
    { key: 'choose', value: '', text: 'Choose one' },
    { key: 'male', value: 'MALE', text: 'MALE' },
    { key: 'female', value: 'FEMALE', text: 'FEMALE' },
    { key: 'neutral', value: 'NEUTRAL', text: 'NEUTRAL' },
  ];

  const getVoices = () => {
    return languageOptions
    .filter(itm => itm.gender === genderFilter || genderFilter === '')
    .filter(el => el.language === languageFilter || languageFilter === '')
    .filter(el => el.type === typeFilter || typeFilter === '');
  };

  const updateAIProcessName = (val) => {
    setAIProcessName(val);
    tableData.name = val;
    localData.tableData = tableData;
    localData.AIProcessName = val;

    if(localData.fieldType===undefined) {
      localData.fieldType= fieldType;
    }

    updateData(localData);
  };


  const updateVoice = (val) => {
    setVoice(val);
    localData.voice = val;
    updateData(localData);
  };


  const extractUniqueTokens = (inputString) => {
    const regex = /\{\{([^}]+)\}\}/g;
    const tokens = [];
    let match;

    while ((match = regex.exec(inputString)) !== null) {
      const token = match[0];

      // Check if the token is already in the array
      const tokenExists = tokens.some((existingToken) => existingToken.token === token);

      if (!tokenExists) {
        tokens.push({
          token: token,
          value: '',
        });
      }
    }

    return tokens;
  };

  const updateTokenValue = (token, value) => {
    const copyArray = structuredClone(tokenArray);
    const idx = copyArray.findIndex((tkn) => tkn.token === token);
    if (idx !== -1) {
      copyArray[idx].value = value;
    }
    setTokenArray(copyArray);
  };

  const updatePromptMessage = (val) => {
    setPromptMessage(val);
    const tokens = extractUniqueTokens(val);
    setTokenArray(tokens);

    localData.promptMessage = val;
    localData.tokenArray = tokens;
    updateData(localData);
    //pare out tokena nd put into array, so user can enter test values.
  };

  const callAIProcess = async () => {
    let finalPromptMessage = promptMessage;

    tokenArray.map((tkn) => {
      finalPromptMessage = finalPromptMessage.replaceAll(tkn.token, tkn.value);
    });

    const eventData = {voice};

    const gbResponse = await aiProcessAPI(finalPromptMessage, 'speech', eventData);
    setAPIResponse(gbResponse);

    localData.apiData = gbResponse;
    updateData(localData);
  };

  const getLanguages = async () => {
    setIsLoading(true);
    const result = await aiTextToSpeechLanguages();
    setLanguageOptions(result);
    setIsLoading(false);
  }

  const getAllFields = () => {

    const allOptions = [{ key: '0', value: '', text: 'Choose field' }];

    sourceNodes.map((node) => {
      node.data.insertMultiple == null &&
        node.data?.tableData?.tableinfo?.columns.map((col) => {
          const idx = allOptions.findIndex(
            (itm) => itm.key === `${node.data.tableData.id}||${col.data}`,
          );
          if (idx === -1) {
            allOptions.push({
              key: `${node.data.tableData.id}||${col.data}`,
              value: `${node.data.tableData.name}::${node.data.tableData.id}||${col.header}`,
              text: `${node.data.tableData.name}||${col.header}`,
            });
          }
        });
    });

    setAllFields(allOptions);
  };

  return (
    <div
      style={{
        backgroundColor: '#fff',
        minHeight: '300px',
        border: '1px solid #0D99FF',
        borderRadius: '5px',
        padding: '20px',
        paddingBottom: '20px',
      }}
    >
      {!isLoading? (<>

      <div style={{ marginBottom: '10px', fontSize: '20px', fontWeight: 'bold' }}>
        Action details
      </div>
      <div>
        AI Text-to-Speech Name:{' '}
        <Input
          value={AIProcessName}
          fluid
          onChange={(e, data) => updateAIProcessName(data.value)}
        />
      </div>
      <div style={{marginTop:'10px'}}>Field type (how field will be seen in subsequent actions)</div>
      <div>
        <Dropdown selection fluid options={fieldTypeOptions} value={fieldType} onChange={(e,data)=>updateFieldType(data.value)} />
      </div>

      <div style={{ marginTop: '10px' }}>Voice filters</div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center',height:'60px' }}>
        <div>
          <Dropdown
            clearable
            search
            value={languageFilter}
            selection
            options={FilterLanguages}
            onChange={(e, data) => setLanguageFilter(data.value)}
          />
        </div>
        <div style={{ width: '100px', marginLeft: '10px', marginRight: '10px' }}>
          <Dropdown  clearable value={genderFilter} onChange={(e,data)=>setGenderFilter(data.value)} fluid selection options={FilterGenders} />
        </div>
        <div style={{ width: '100px' }}>
          <Dropdown  clearable fluid value={typeFilter} selection options={FilterTypes}  onChange={(e,data)=>setTypeFilter(data.value)} />
        </div>
      </div>
      <div style={{marginTop:'10px'}}>
        <div>Voices</div>
        <Dropdown fluid value={voice} onChange={(e,data)=>updateVoice(data.value)}  search selection options={getVoices()} />
      </div>
      <div>
        <div style={{ marginTop: '15px', marginBottom: '10px' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div style={{ whiteSpace: 'nowrap', marginRight: '5px' }}>Field tokens</div>
            <Dropdown
              clearable
              search
              selectOnBlur={false}
              options={allFields}
              fluid
              selection
              onChange={(e, data) =>
                data.value != '' ? updatePromptMessage(promptMessage + `{{${data.value}}}`) : null
              }
            />
          </div>

          <Form>
            <TextArea
              style={{
                marginTop: '20px',
                fontSize: '12px',
                height: '200px',
                border: '1px solid black',
                borderRadius: '10px',
                // width: '470px',
              }}
              onChange={(e, data) => updatePromptMessage(data.value)}
              value={promptMessage}
              placeholder="Enter text here"
            />
          </Form>

          {tokenArray.length > 0 ? (
            <table style={{ marginTop: '10px' }}>
              <tr>
                <th>Token</th>
                <th>Test value</th>
              </tr>
              {tokenArray.map((tkn) => (
                <tr>
                  <td>{tkn.token}</td>
                  <td>
                    <Input
                      value={tkn.value}
                      onChange={(e, data) => updateTokenValue(tkn.token, data.value)}
                    />
                  </td>
                </tr>
              ))}
            </table>
          ) : null}

          <div style={{ marginTop: '10px', marginBottom: '10px', }}>
            <GBButton text="Get response" padding="10px" color={'#0D99FF'} Action={callAIProcess} />
          </div>

          {APIResponse && APIResponse.error===null ? (
            <div style={{ maxHeight: '300px', overflow: 'auto',padding:'20px' }}>
              MP3 URL: {APIResponse.publicUrl}
              <AudioPlayer mp3Url={APIResponse.publicUrl} />
             </div>
          ) : null}

        {APIResponse && APIResponse.error !==null ? (
            <div style={{ maxHeight: '300px', overflow: 'auto',padding:'20px' }}>
              {APIResponse.error}
             </div>
          ) : null}
     

        </div>
      </div>
      </>): <Spinner />}
    </div>
  );
};

export default ActionAITextToSpeech;
